import * as React from "react";

import {type IconSize} from "@khanacademy/wonder-blocks-icon";
import {color, sizing} from "@khanacademy/wonder-blocks-tokens";
import {faceIconColor} from "@khan/auth-shared";

/**
 * Facebook icon component that renders a Facebook logo SVG.
 */
export const FacebookIcon = ({
    disabled = false,
    ariaHidden,
    size,
}: {
    // Whether the icon should appear disabled
    disabled: boolean;
    // Whether the icon should be hidden from screen readers
    ariaHidden: boolean;
    // The size of the icon.  Uses Wonder Blocks icon sizing ("small", "medium", "large", "xlarge")
    size?: IconSize;
}): React.ReactElement<React.ComponentProps<"svg">> => {
    const fadeFn = faceIconColor(disabled);

    // Convert size string to Wonder Blocks sizing token
    const sizeMap = {
        small: sizing.size_160,
        medium: sizing.size_240,
        large: sizing.size_320,
        xlarge: sizing.size_400,
    };
    const iconSize = size ? sizeMap[size] : sizeMap.medium;

    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden={ariaHidden}
            xmlns="http://www.w3.org/2000/svg"
            width={iconSize}
            height={iconSize}
        >
            <path
                d="M22 11.5C22 6.25 17.75 2 12.5 2C7.25 2 3 6.25 3 11.5C3 16.24 6.47 20.17 11.02 20.89V14.25H8.60V11.5H11.02V9.41C11.02 7.03 12.43 5.71 14.60 5.71C15.64 5.71 16.73 5.90 16.73 5.90V8.23H15.53C14.35 8.23 13.98 8.97 13.98 9.72V11.5H16.62L16.20 14.25H13.98V20.89C18.53 20.17 22 16.24 22 11.5Z"
                fill={fadeFn("#1877F2")}
            />
            <path
                d="M16.20 14.25L16.62 11.5H13.98V9.72C13.98 8.97 14.35 8.23 15.53 8.23H16.73V5.90C16.73 5.90 15.64 5.71 14.60 5.71C12.43 5.71 11.02 7.03 11.02 9.41V11.5H8.60V14.25H11.02V20.89C11.50 20.96 12.00 21 12.5 21C13.00 21 13.50 20.96 13.98 20.89V14.25H16.20Z"
                fill={fadeFn(color.white)}
            />
        </svg>
    );
};
